import { actions as jobModuleActions } from '@saucelabs/sl-module-jobs';
import { actions as notificationActions } from '@saucelabs/sl-container-notifications';
import { functions as webdriverCommandFunctions } from '@saucelabs/sl-module-webdriver-commands';
import { push, replace } from 'connected-react-router';
import { scrollToElementIfNotVisible } from '@saucelabs/sl-util-helpers';

import { allCommandsSelector, filteredCommandsSelector, location } from '../container/selectors';
import * as actions from './actions';
import * as containerConstants from '../container/constants';


export const changeJobVisibility = ({ id, visibility, username }) => (dispatch) => (
  dispatch(jobModuleActions.changeVisibility({ id, visibility, username }))
    .then(() => dispatch(notificationActions.notifySuccess('Visibility changed')))
    .catch(() => dispatch(notificationActions.notifyDanger(
      'We were not able to change job visibility',
    )))
);

export const deleteJob = ({ id, username }) => (dispatch) => (
  dispatch(jobModuleActions.deleteJob({ id, username }))
    .then(() => dispatch(push('/dashboard/tests')))
    .catch(() => dispatch(notificationActions.notifyDanger(
      'We were not able to delete the job',
    )))
);

export const breakpointJob = ({ id, username }) => (dispatch) => (
  dispatch(jobModuleActions.breakpointJob({ id, username }))
    .then(() => dispatch(notificationActions.notifySuccess('Job breakpointed')))
    .catch(() => dispatch(notificationActions.notifyDanger(
      'We were not able to breakpoint the job, please try again',
    )))
);

export const stopJob = ({ id, username }) => (dispatch) => (
  dispatch(jobModuleActions.stopJob({ id, username }))
    .then(() => dispatch(notificationActions.notifySuccess('Job stopped')))
    .catch(() => dispatch(notificationActions.notifyDanger(
      'We were not able to stop the job, please try again',
    )))
);

export const updateActiveCommand = (payload) => (dispatch, getState) => {
  const { collapseCurrent, commandId, currentTime } = payload;
  const allCommands = allCommandsSelector(getState());
  const filteredCommands = filteredCommandsSelector(getState());
  const routerLocation = location(getState());

  // It's possible that active command is currently filtered out. We should stil deactivate it.
  const oldActive = allCommands.findIndex((command) => command.active);

  let newActive;
  if (Number.isFinite(currentTime)) {
    const activeCommand = webdriverCommandFunctions.findActiveCommand({
      commands: filteredCommands,
      currentTime,
    });
    if (activeCommand) {
      newActive = activeCommand.id;
    }
  }
  if (Number.isFinite(commandId)) {
    newActive = commandId;
  }

  if (Number.isFinite(newActive)) {
    Promise.all([
      dispatch(replace({ ...routerLocation, hash: `#${newActive}` })),
      dispatch(actions.updateActiveCommand({ collapseCurrent, newActive, oldActive })),
    ]);
    scrollToElementIfNotVisible(
      `command-${newActive}`,
      containerConstants.COMMAND_LIST_CONTAINER_ID,
      { duration: 100, smooth: true },
    );
  }
};
